import { Box, Chip, Stack, Typography } from '@mui/material';
import { Share } from '@mui/icons-material';
import { CompanyShareSelection } from '../../../dto/MessageSharing.dto';

interface ChildSharingReviewSummaryProps {
  shareSelections: CompanyShareSelection[];
}

/**
 * Displays a read-only summary of which child partners a message is shared with.
 * Used in review steps of message steppers (Stinger, ESM, Base Message).
 */
const ChildSharingReviewSummary: React.FC<ChildSharingReviewSummaryProps> = ({
  shareSelections,
}) => {
  if (!shareSelections.length) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Share fontSize="small" sx={{ color: 'text.secondary' }} />
        <Typography variant="h6" className="text-white-50">
          Shared with Child Partners
        </Typography>
      </Stack>
      <Stack direction="row" flexWrap="wrap" gap={1}>
        {shareSelections.map(selection => (
          <Chip
            key={selection.companyId}
            label={selection.companyName || `Company #${selection.companyId}`}
            size="small"
            variant="outlined"
            color="primary"
          />
        ))}
      </Stack>
    </Box>
  );
};

export default ChildSharingReviewSummary;
